import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import * as classes from './classes.module.scss';

export default class UploadLogo extends PureComponent {
  static propTypes = {
    setLogo: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
  };

  input = React.createRef();

  componentDidMount() {
    this.input.current.click();
  }

  onFileSelected = (e) => {
    const { setLogo, onCancel } = this.props;
    const reader = new FileReader();
    const file = e.target.files[0];
    reader.addEventListener('load', () => {
      setLogo(reader.result);
      onCancel();
    }, false);
    reader.readAsDataURL(file);
  }

  render() {
    return (
      <div className={ classes.uploading  }>
        <label
          htmlFor="logoFile"
          className={ classes.uploadFile }
        >
          UPLOAD LOGO
          <input
            type="file"
            accept=".png, .jpg, .jpeg"
            onChange={ this.onFileSelected }
            ref={ this.input }
            name="logoFile"
            id="logoFile"
          />
        </label>
      </div>
    );
  }
}
